import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is loaded
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import './App.css';
import AboutSection from './components/AboutSection/AboutSection';
import WhatWeDo from './components/WhatWeDo/WhatWeDo';
import Features from './components/Features/Features';
import Projects from './components/Project/Project';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/Faq/Faq';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/FooterSection';
import WhatsApp from './components/WhatsApp/WhatsApp';
function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        {/* IDs added here to match the links */}
        <section id="home"><Hero /></section>
        <section id="about"><AboutSection/></section>
        <section id="services"><WhatWeDo/></section>
        <section id="features"><Features/></section>
        <section id="projects"><Projects/></section>
        <section id="testimonials"><Testimonials/></section>
        <section id="faq"><FAQ/></section>
        <section id="contact"><Contact/></section>
      </main>
      <Footer/>
      <WhatsApp/>
    </div>
  );
}

export default App;
//